import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class SoilPhAttribute extends Sensor {
  public soilPhChart: any;
  private soilPhSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.soilPhChart = null;
    this.soilPhSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.soilPhSensor, position);
      this.soilPhSensor[position].push([timestamp, element.soilPh]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredSoilPh = this.soilPhSensor.filter(series => series.length > 0);

    const positionNodeSoilPh = this.soilPhSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.soilPhChart = this.getConfigChar(
      'soilPh',
      this.getChartSeriesNewNode('PH DEL SUELO', filteredSoilPh, positionNodeSoilPh),
      this.getRanges('soilPh'),
      this.getLimits('soilPh')
    );
  }

  public hasSoilPhSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.soilPhSensor.length &&
      this.soilPhSensor[index].length > 0
    );
  }

  public getSoilPhSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.soilPhSensor.length) {
      const sensorData = this.soilPhSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'PH del Suelo', value: 'soilPh' }
    ];
  }
}
